/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import FirstStepIcon from 'assets/icons/firstStep';
import { CountUp, StepIcon } from 'components';
import * as S from './styles';
import { ICustomTheme } from 'interfaces';

const { cssMarginBottom } = S;

type SpecificGoalType = {
  disabled: boolean;
  name?: string;
  value?: number;
  unit?: string;
  subject?: string;
};

const SpecificGoal = ({
  disabled,
  name,
  value,
  unit,
  subject,
}: SpecificGoalType): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <Grid container justify="center" css={cssMarginBottom}>
        <Grid item>
          <StepIcon
            icon={<FirstStepIcon fontSize="inherit" />}
            status={disabled ? 'disabled' : 'done'}
            size={isDownSm ? 'medium' : 'large'}
          />
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item>
          <S.GoalNameValue
            className={disabled ? 'disabled' : ''}
            variant={isDownSm ? 'body2' : 'h4'}
          >
            {name}
            &nbsp;
            {value !== undefined ? (
              <CountUp end={Number(value)} />
            ) : (
              <S.ContactAdmin>
                {/* [ */}
                &#91;
                {t('core.no_information')}
                {/* space - space */}
                &nbsp;&#45;&nbsp;
                {t('core.contact_admin')}
                &#93;
                {/* ] */}
              </S.ContactAdmin>
            )}
          </S.GoalNameValue>
          {(unit || subject) && (
            <S.GoalUnit variant={isDownSm ? 'body2' : 'h4'}>
              {unit} {subject}
            </S.GoalUnit>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default SpecificGoal;
